<template>
  <div class="feedback-form">
    <p class="feedback-text">At Fly, we value your feedback and continually improve our tool based on your insights.</p>
    <textarea v-model="feedback" placeholder="Describe your suggestion" rows="8"></textarea>
    
    <div v-if="errorMessage" class="error-message text-red-500">{{ errorMessage }}</div>
    
    <button class="submit-button" @click="submitFeedbackInternal" :disabled="loading">
       <v-icon v-if="loading" small class="mr-2">mdi-loading</v-icon>
       Submit <v-icon small color="white" class="ml-2">mdi-send</v-icon>
    </button>
  </div>
</template>

<script>
export default {
  props: {
    loading: Boolean,
    initialFeedback: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      feedback: this.initialFeedback,
      errorMessage: '',
    };
  },
  watch: {
    initialFeedback(newVal) {
      this.feedback = newVal;
    }
  },
  methods: {
    submitFeedbackInternal() {
      if (this.feedback.trim().length === 0) {
        this.errorMessage = 'Please enter some suggestion';
        return;
      }
      this.errorMessage = ''; // Clear error message
      this.$emit('submit-feedback', this.feedback);
    },
    clearInput() {
      this.feedback = '';
      this.errorMessage = '';
    }
  }
};
</script>

<style scoped>
.feedback-form {
  margin-top: 10px;
  display: flex;
  flex-direction: column;
}
.feedback-text {
  font-size: 16px;
  margin-bottom: 10px;
}
textarea {
  width: 100%;
  min-height: 120px;
  margin-top: 10px;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
  resize: vertical;
}
.submit-button {
  align-self: flex-end;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 5px;
  padding: 10px 15px;
  cursor: pointer;
  display: flex;
  align-items: center;
  margin-top: 10px;
}
.submit-button i {
  margin-right: 5px;
}
.error-message {
  margin-top: 10px;
  align-self: flex-start; /* Align error message to the left */
}

/* Responsive Design */
@media (max-width: 600px) {
  textarea {
    min-height: 100px;
  }
}
</style> 